module.exports = __webpack_public_path__ + "static/media/teachers-logo--new.eaf45896.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/teachers-logo--new.svg
// module id = 494
// module chunks = 0